<template>
  <div class="col-7 col-lg-7">
    <small :id="'review-user-'+index"
											data-test="reviewedUserInformationHead">
      By {{reviewedUser}}
      <span class="verifieduser">
        <img
          class="icon_cnt"
          src="@/assets/svg/iconmonstr-check-mark-8.svg"
          alt="Verified User Icon"
          srcset
          :id="'check-mark-'+index"
										data-test="reviewedUserInformationImg"
        >
        verified user
      </span>
    </small>
  </div>
</template>

<script>
export default {
	name: 'reviewed-user-information',
	props: {
		reviewedUser: null,
		index: {
			default: 0,
			type: Number
		}
	}
}
</script>
